function removeFromCartByVariantID(variantID) {
    // Fetch the current cart data
    fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {

            const lineItem = cartData.items.find(item => item.variant_id === parseInt(variantID));

            if (lineItem) {
                fetch('/cart/update.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: {
                                [lineItem.key]: 0
                            }
                        }),
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Request failed with status ' + response.status);
                        }
                        console.log('Successfully removed item from the cart');
                    })
                    .catch(error => {
                        console.error('Error occurred:', error);
                    });
            } else {
                console.log(`Item with variant ID ${variantID} not found in the cart`);
            }
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
}

var wrapping = {
	basic_id: null,
	gift_handle: 'gift-wrapping',
	premium_id: null,
	required_fields: $('#cartform__gift').find('.required'),
	init: function(){
		var that = this;
		var $gift_fields = $('#cartform__gift');
		var $checkout_buttons = $('#cart-buttons');
		this.set_variant_ids();
		this.text_limit();
		this.validate(); 

		$('#preference').on('change', function () {
			var nameField = $('#recipients-name');
			var cardField = $('input[name="attributes[Card?]"]');
			if ($(this).is(":checked")) {
				nameField.removeAttr('required').removeClass('required error');
				cardField.val('No');
			} else {
				nameField.prop('required', true).addClass('required');
				cardField.val('Yes');
			}
		}).change();

		$('#js-giftOptions').click(function(e){
			$gift_fields.toggleClass('off');
			if($(this).prop( "checked" )){
				$gift_fields.show();
			} else {
				$gift_fields.hide();
			}
		});

		$('#sidecart-container, .cart-container').on('click', '.wrapping-options-wrapper', that, function(e) {
			e.preventDefault();
			var target = $(this).find('input');
			
			$('.wrapping-options-wrapper input').attr('checked', false);
			target.attr('checked', true);
		});

        $('#sidecart-container .gift-options #gift-button').click(function(e){
			e.preventDefault();

            removeFromCartByVariantID(28319750921);
            removeFromCartByVariantID(wrapping.basic_id);
            removeFromCartByVariantID(wrapping.premium_id);
		});

		//$( document ).on( "click", ".cartQuantity", that, function(e) {
			//e.preventDefault();
			//console.log('done-wrapping');
			//e.data.update_product_quantity(e,this);
		//});

		// remove the error label that the form validation is leaving around and breaking layout
		$('.wrapping-options-wrapper, .cart-container').on('click', function(){
			var $error_label = $(".wrapping-options-wrapper").find('label.error');
			if($error_label.length > 0){
				$error_label.remove();
			}
		});

	},
	removeFromCartByVariantID: function(variantID) {
		// Fetch the current cart data
		fetch('/cart.js')
			.then(response => response.json())
			.then(cartData => {
	
				const lineItem = cartData.items.find(item => item.variant_id === parseInt(variantID));
	
				if (lineItem) {
					fetch('/cart/update.js', {
							method: 'POST',
							credentials: 'same-origin',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								updates: {
									[lineItem.key]: 0
								}
							}),
						})
						.then(response => {
							if (!response.ok) {
								throw new Error('Request failed with status ' + response.status);
							}
							console.log('Successfully removed item from the cart');
						})
						.catch(error => {
							console.error('Error occurred:', error);
						});
				} else {
					console.log(`Item with variant ID ${variantID} not found in the cart`);
				}
			})
			.catch(error => {
				console.error('Error fetching cart:', error);
			});
	},
	add_cart_shipping: function(variant_option_id){
		var that = this;
        console.log('add_cart_shipping ----- this');
        console.log(this);

		var cart_count_promise = this.get_cart_count(variant_option_id),
		chained = cart_count_promise.then(function( cart_count_data ) {

                console.log('add_cart_shipping ----- cart_count_promise');
                console.log( cart_count_promise );
                console.log('add_cart_shipping ----- cart_count_data');
                console.log( cart_count_data );
                console.log( this.get_cart_count() );
			
				CartJS.addItem(variant_option_id, cart_count_data, {}, {

					// Define a success callback to display a success message.
					"success": function(data, textStatus, jqXHR) {
						// openCart();
					},

					// Define an error callback to display an error message.
					"error": function(jqXHR, textStatus, errorThrown) {
						// error
						var error_msg = jqXHR.responseJSON.description;
						console.log('error1 '+error_msg);
						// showError(error_msg);
					}
				});
		});
		
		chained.done(function( data ) {
		that.update_dom();
		});

	},
	add_cart: function(variant_id, count){
		var data = {quantity: count,id: variant_id};
		var promise = $.ajax({
		type: "POST",
		url: "/cart/add.js",
		data: data,
		dataType: "json"
		});
		return promise;
	},
	get_cart_count: function(variant_option_id){
		var promise = $.Deferred();
		$.ajax({
    		url: "/cart.js",
    		dataType: "json",
    		success: function(result){
    			var cart_count = 0;
    			$.each(result.items, function( index, line_item ) {
        			cart_count += line_item.quantity;
    			});
                console.log( cart_count );
    			promise.resolve(cart_count);
    		}
		});
		return promise;
	},
	format_price: function(price){
		var formatted_price = price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
		formatted_price = "$"+formatted_price;
		return formatted_price;
	},
	reset_cart_wrapping: function(variant_option_id){
		var that = this;
		var data = "updates["+this.basic_id+"]=0&updates["+this.premium_id+"]=0";
		var reset_wrapping = that.update_cart(data);

        console.log('reset_cart_wrapping() ------that');
        console.log(that);
        console.log('reset_cart_wrapping() ------data');
        console.log(data);
        console.log('reset_cart_wrapping() ------reset_wrapping');
        console.log(reset_wrapping);

		$.when(reset_wrapping).then(function(reset_wrapping_data){
            console.log('reset_cart_wrapping() ------reset_wrapping_data');
            console.log(reset_wrapping_data);
			if(variant_option_id){
				that.add_cart_shipping(variant_option_id);
			} else {
				that.update_dom();
				CartJS.setAttributes(CartJS.getAttributes());
			}
		});

	},
	set_variant_ids: function(){
		$.getJSON('/products/'+wrapping.gift_handle+'.js', function(product) {
			wrapping.basic_id = product.variants[1].id;
			wrapping.premium_id = product.variants[2].id;
		});
	},
	// expects price to be formatted in dollars
	sum_price: function(price){
		var old_price = Number($('#js-subtotal span').text().replace('$','').replace(',',''));
		var sum_price = Number((price)+old_price);
		var formatted_price = this.format_price(sum_price);
		
		return formatted_price;
	},
	text_limit: function(){
		var note_input = document.getElementById("gift_note");

		if (note_input != null){

    		var char_counter = document.getElementById("note-char-limit");
    		var charLimit = 300;
    
    		var updateCharCount = function(){
    			var curr_length = note_input.value.length;
    
    			if (curr_length >= charLimit){
        			var limited = note_input.value.substring(0, charLimit);
        			note_input.value = limited;
        			curr_length = note_input.value.length;
        			addClass(char_counter, "max");
    			} else {
        			removeClass(char_counter, "max");
    			}
    
    			char_counter.innerHTML = charLimit - curr_length + " characters left";
    		}

    		updateCharCount(300);
    		addListener(note_input, "keyup", updateCharCount);
		}
	},
	update_cart: function(data){
		var promise = $.ajax({
    		type: "POST",
    		url: "/cart/update.js",
    		data: data,
    		dataType: "json"
		});
		return promise;
	},
	update_dom: function(){
		var that = this;
		$.ajax({
    		url: "/cart",
    		dataType: "html",
    		cache: false,
    		success: function(response_data){
    			var $form = $('#cartform');
    			var updated_products = $(response_data).find('.cartItem');
    			var updated_price = $(response_data).find('#js-subtotal_span').text();
    			// prevent page jump on append
    			var old_height = $(document).height();  //store document height before modifications
    			var old_scroll = $(window).scrollTop();
    			
    			$form.find('.cartItem').remove();
    			$form.prepend(updated_products);
    
    			that.update_price(updated_price);
    		}
		});
	},
	update_product_quantity: function(e,element){
		var that = e.data;
		var $product = $(element).closest('.cartItem');
		var is_regular_product = $product.hasClass('js-regularProduct');
		var id = $product.attr('id');
		var $quantity_element = $('#updates_'+id);
		
		var $gift_wrapping = $('.js-giftWrapping');
		var gift_wrapping_id = $gift_wrapping.attr('id');
		// decrement product quantity
		if (e.target.className === 'minusCart') {
			var quantity = parseInt($quantity_element.val());
			if(quantity !== 0){
				--quantity;
				var data = "updates["+id+"]="+quantity;
				that.update_cart(data).done(function(result){
					$quantity_element.val(quantity);
					that.update_price(that.format_price(result.total_price/100));
					// decrement the wrapping product
					// if the click is on a regular product(not gift wrap) and a gift wrap product is in the cart
					if(is_regular_product && $gift_wrapping.length > 0){
						var $quantity_element_wrapping = $gift_wrapping.find('.itemQty');
						var quantity_wrapping = parseInt($quantity_element_wrapping.val());
						--quantity_wrapping;
						var data_wrapping = "updates["+gift_wrapping_id+"]="+quantity;
						that.update_cart(data_wrapping).done(function(result_wrapping){
							$quantity_element_wrapping.val(quantity_wrapping);
							that.update_price(that.format_price(result_wrapping.total_price/100));
						});
					}
				});
			}
		//increment product quantity
		} else {
			var cart_promise = that.add_cart(id, 1);
			cart_promise.done(function(result){
				$quantity_element.val(result.quantity);
				// update the price with a sum of the result and cart price
				that.update_price(that.sum_price(result.price/100));

				// increment the gift wrapping
				// if the click is on a regular product(not gift wrap) and a gift wrap product is in the cart
				if(is_regular_product && $gift_wrapping.length > 0){
					var cart_promise_wrapping = that.add_cart(gift_wrapping_id, 1);
					cart_promise_wrapping.done(function(result_wrapping){
                        console.log('update_product_quantity() ------result_wrapping');
                        console.log(result_wrapping);
                        console.log('update_product_quantity() ------result_wrapping.quantity');
                        console.log(result_wrapping.quantity);
						$gift_wrapping.find('.itemQty').val(result_wrapping.quantity);
						that.update_price(that.sum_price(result_wrapping.price/100));
					});
				}
			});
		}
	},
	update_price: function(price){
		$('#js-subtotal span').text(price);
	},
	validate: function(){
		$("#cartform").validate({
			submitHandler: function(form) {
			form.submit();
			}
		});
	}
};

$( document ).ready(function() {
	wrapping.init();		
});

// add class
function addClass(el, className){
	if (el.classList){
		el.classList.add(className);
	}
	else {
		el.className += ' ' + className;
	}
};

// remove class
function removeClass(el, className){
	if (el.classList){
		el.classList.remove(className);
	}
	else {
		el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	}
};

// toggle class
function toggleClass(el, className){
	if (el.classList) {
		el.classList.toggle(className);
	} else {
		var classes = el.className.split(' ');
		var existingIndex = -1;
		for (var i = classes.length; i--;) {
			if (classes[i] === className)
			existingIndex = i;
		}

		if (existingIndex >= 0)
			classes.splice(existingIndex, 1);
		else
			classes.push(className);

		el.className = classes.join(' ');
	}
};

// has class
function hasClass(el, className){
	if (el.classList)
		return el.classList.contains(className);
	else
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
}

// add listener
function addListener(el, eventName, handler) {
	if (el.addEventListener) {
		el.addEventListener(eventName, handler);
	} else if (el.attachEvent){
		el.attachEvent('on' + eventName, function(){
		handler.call(el);
		});
	} else {
		el["on" + eventName] = handler;
	}
}

function removeListener(el, eventName, handler) {
	if (el.removeEventListener){
		el.removeEventListener(eventName, handler);
	} else {
		el.detachEvent('on' + eventName, handler);
	}
}